import styled, { css } from 'styled-components';

import { variableFontRegular } from 'styles/theme/text';
import { ProductBreadcrumbs } from 'productTemplate/components/footer/ProductBreadcrumbs';
import { useStoreSelector } from 'store/hooks/storeHooks';

export const ProductInfo = () => {
  const { name, releaseDate, releaseYear } = useStoreSelector((state) => state.pdp.productTemplate);
  const year = releaseYear || new Date(releaseDate).getFullYear() || '';

  return (
    <ProductInfo.Wrapper $hasYear={!!year} data-qa="product_year">
      <ProductInfo.Container>
        {year && <span>{year}</span>}
        {/* Added to absolute position without losing the space in the parent grid */}
        <ProductInfo.InternalContainer $hasYear={!!year}>
          <ProductInfo.Name data-qa="product_name">{name}</ProductInfo.Name>
          <ProductBreadcrumbs />
        </ProductInfo.InternalContainer>
      </ProductInfo.Container>
    </ProductInfo.Wrapper>
  );
};
// Edit position relative to prevent the bottom footer from overlapping with top footer
// Added min-width 110px in the product info wrapper
// Due to fixed widths in the middle child of their flex parent,
// this ensures the name of the product isn't cut off right before the mobile breakpoint
// TODO: needs to be revisited if possible with the design team
// so we can responsively let components take up their assigned spaces fully

ProductInfo.Wrapper = styled.div<{ $hasYear: boolean }>`
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  flex-direction: row;
  flex: 1;
  height: 100%;
  z-index: ${({ theme }) => theme.zIndex.pdpFooterItem};
  @media (max-width: ${({ theme }) => theme.breakpoints.mediumSmall - 1}px) {
    padding-right: 8px;
    width: 196px;
    ${({ $hasYear }) =>
      $hasYear
        ? css`
            padding-left: 16px;
          `
        : css`
            padding-left: 8px;
          `}
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
    padding-top: 14px;
    min-width: 110px;
    position: relative;
    ${variableFontRegular({ height: '14px', size: '11.5px' })};
  }
`;

// edit bottom: 0 to prevent overlap with bottom footer
// padding 32px  to center with the buybardesktop
ProductInfo.Container = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  gap: 8px;

  @media (min-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
    padding-left: 32px;
    position: absolute;
    bottom: 0;
    gap: 16px;
    padding-bottom: 32px;
  }
`;

// TODO: remove plain function. It just adds complilation overhead
// since it only returns the font-family
// this could be loaded either statically in the common app css or in the theme
// if we have different fonts for different themes
// this is also a great opportunity for centralization.
// EG: Remove all plain function as the styled.h1 will be a custom components from UX system design common throughout the app

ProductInfo.Name = styled.h1`
  font-weight: normal;
  margin: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.mediumSmall - 1}px) {
    ${variableFontRegular({ height: '16px', size: '11.5px' })};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
    ${variableFontRegular({ height: '14px', size: '11.5px' })};
  }
`;

ProductInfo.InternalContainer = styled.div<{ $hasYear: boolean }>`
  ${({ $hasYear }) =>
    !$hasYear &&
    css`
      padding-left: 8px;
    `}
`;
